export const TERMS_AND_CONDITIONS = 0
export const PRIVACY_AND_POLICY = 1
